import { Link } from 'react-router-dom';
import { LeafMark } from './LeafMark';

const actionClasses =
  'mt-5 inline-flex min-h-tap items-center rounded-lg bg-accent px-5 text-sm font-semibold text-accent-contrast shadow-sm transition-colors hover:bg-accent-strong';

interface EmptyStateProps {
  title: string;
  note: string;
  /** Renders a router `<Link>` action when paired with `actionLabel`. */
  actionTo?: string;
  /** Renders a `<button>` action when paired with `actionLabel`. */
  actionOnClick?: () => void;
  actionLabel?: string;
}

/**
 * The shared empty-state recipe (docs/DESIGN.md): the leaf mark, one Fredoka line, one muted
 * sentence, one accent action. Used everywhere a list has nothing in it yet (no accounts, no
 * tasks enabled, no goals) instead of each route hand-rolling its own "nothing here" card.
 */
export function EmptyState({ title, note, actionTo, actionOnClick, actionLabel }: EmptyStateProps) {
  return (
    <section className="rounded-xl border border-dashed border-border-strong bg-bg-elevated p-8 text-center">
      <LeafMark className="mx-auto text-text-faint" size={28} />
      <p className="mt-3 font-display text-base font-semibold text-text">{title}</p>
      <p className="mx-auto mt-2 max-w-sm text-sm text-text-muted">{note}</p>
      {actionLabel && actionTo && (
        <Link to={actionTo} className={actionClasses}>
          {actionLabel}
        </Link>
      )}
      {actionLabel && actionOnClick && (
        <button type="button" onClick={actionOnClick} className={actionClasses}>
          {actionLabel}
        </button>
      )}
    </section>
  );
}
